export enum ToastMessages {
  WHITE_LIST_REQUEST = 'Your account is adding to Proposal\'s Whitelist. Please wait',
  WHITE_LIST_ERROR = 'Your account has not been added to Whitelist, please try again later',
  WHITE_LIST_SUCCESS = 'Your account has been added to Whitelist successfully',
  TRANSACTION_REQUEST = 'Transaction in Progress.',
  TRANSACTION_SUCCESS = 'Transaction has been successfully completed',
  TRANSACTION_ERROR = 'Transaction has been failed',
}
